import { motion } from "framer-motion";
import { RotateCcw, Moon, Info } from "lucide-react";
import {
  SECONDARY_NOTE,
  CICLO_NOTE,
  R_MEDICAL_NOTE,
  DISCLAIMER,
} from "../data/quiz";
import { BREVO_FORMS } from "../config/brevoForms";

export const ResultScreen = ({ result, onRestart }) => {
  const openBrevo = () => {
    const link = BREVO_FORMS[`${result.profile}_${result.level}`];
    if (link) window.location.href = link;
  };

  return (
    <motion.div
      key="result"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      className="flex flex-1 flex-col"
      data-testid="result-screen"
    >
      <p className="text-center text-xs font-semibold uppercase tracking-wider text-coral">
        Il tuo profilo
      </p>

      <div className="mt-4 rounded-3xl bg-white/80 p-6 shadow-sm">
        <div className="flex items-start justify-between gap-4">
          <h2
            className="font-serif text-2xl font-bold leading-tight text-ink"
            data-testid="result-profile-name"
          >
            {result.profileName}
          </h2>
          <span
            className="shrink-0 rounded-full bg-coral px-4 py-1.5 text-sm font-semibold text-white"
            data-testid="result-level-badge"
          >
            {result.level}
          </span>
        </div>

        <div
          className="mt-5 rounded-r-xl border-l-4 border-coral bg-coral/5 py-3 pl-4 pr-3"
          data-testid="result-explanation"
        >
          <p className="text-sm leading-relaxed text-ink/80">{result.profileText}</p>
        </div>

        {result.mixed && (
          <div className="mt-4 flex gap-3 rounded-xl bg-ink/[0.04] p-4" data-testid="result-secondary-note">
            <Info size={18} className="mt-0.5 shrink-0 text-coral" strokeWidth={2} />
            <p className="text-sm leading-relaxed text-ink/75">
              <span className="font-semibold text-ink">Profilo misto. </span>
              {SECONDARY_NOTE[result.secondary]}
            </p>
          </div>
        )}

        {result.flagCiclo && (
          <div className="mt-4 flex gap-3 rounded-xl bg-ink/[0.04] p-4" data-testid="result-ciclo-note">
            <Moon size={18} className="mt-0.5 shrink-0 text-coral" strokeWidth={2} />
            <p className="text-sm leading-relaxed text-ink/75">{CICLO_NOTE}</p>
          </div>
        )}

        {result.profile === "R" && (
          <p
            className="mt-4 rounded-xl bg-coral/10 p-4 text-sm leading-relaxed text-ink/80"
            data-testid="result-medical-note"
          >
            {R_MEDICAL_NOTE}
          </p>
        )}
      </div>

      <div className="mt-7 flex flex-col gap-3">
        <button
          type="button"
          onClick={openBrevo}
          data-testid="start-program-button"
          className="w-full rounded-2xl bg-coral px-8 py-4 text-lg font-semibold text-white shadow-lg shadow-coral/30 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl active:translate-y-0"
        >
          Inizia il programma gratuito
        </button>

        <p className="text-center text-xs leading-relaxed text-ink/55" data-testid="start-program-note">
          Ti invieremo un'email per confermare l'iscrizione. Il percorso parte il giorno dopo la
          conferma. Le risposte al test non vengono salvate.
        </p>

        <button
          type="button"
          onClick={onRestart}
          data-testid="restart-button"
          className="mt-2 flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-ink/15 bg-transparent px-8 py-4 text-base font-semibold text-ink transition-colors duration-200 hover:border-ink/30 hover:bg-ink/5"
        >
          <RotateCcw size={18} strokeWidth={2.2} />
          Rifai il test
        </button>
      </div>

      <p
        className="mt-5 text-center text-xs leading-relaxed text-ink/50"
        data-testid="result-disclaimer"
      >
        {DISCLAIMER}
      </p>
    </motion.div>
  );
};
